/**
 * @desc 查询网站公告详情
 */
import { NoticeEntity } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryNoticeParameter = {
  id?: string
}

const method = 'GET'
const url = '/content/operation/notice'

export const queryNoticeApi = (
  params?: QueryNoticeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<NoticeEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryNoticeApi.method = method
queryNoticeApi.url = url
